import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TagOutput")
export class TagOutput {
    @JsonProperty()
    public label: string = JsonPropertyEmpty;

    @JsonProperty()
    public slug: string = JsonPropertyEmpty;

    public constructor(args?: Partial<TagOutput>) {
        Object.assign(this, args);
    }
}
